/* ----------  Header JS  ---------- */

const Header = () => {
	const $body = $('body');
	const $nav = $('#navSidebar');
	const $navList = $('.sidebarNavList', $nav);

	const $header = $('#appHeader');
	const $btnToggle = $('.btnToggle', $header);

	const initMiniSidebar = () => {
		$body.trigger('resize');
		$body.addClass('mini-sidebar');

		$('.slimScrollDiv, .scrollSidebar', $nav).css('overflow-x', 'visible').parent().css('overflow', 'visible');
	}

	const initMainMenuToggle = () => {
		$btnToggle.off('click.toggle').on('click.toggle', e => {
			e.preventDefault();

			$body.toggleClass('menu-open');
		});
	}

	const initSubMenu = () => {
		const $items = $('>li', $navList);

		_.map($items, item => {
			const $item = $(item);
			const $submenu = $('>ul', $item);

			if($submenu.length) {
				const $link = $('>a', $item);
				$link.off('click.submenu').on('click.submenu', e => {
					e.preventDefault();

					if($submenu.is(':visible')) {
						$submenu.slideUp();
						$item.removeClass('submenu-open');
					} else {
						$submenu.slideDown();
						$item.addClass('submenu-open');
					}
				});
			}
		})
	}

	return { initMiniSidebar, initMainMenuToggle, initSubMenu };
}
